import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import AdminInviteZoneView from '../../../containers/Zones/Admin/AdminInviteZone';
import { useTokenCallback } from '../../../utils/hooks/useTokenCallback';

const AdminInviteZone = ({match}) => {
  const {communityInfo} = useSelector(state=>state.userInfo)
    const [usersToInvite, setUsersToInvite] = useState([]);
    useTokenCallback(()=>{
        
    },[])
  return <AdminInviteZoneView zone={communityInfo} usersToInvite={usersToInvite} setUsersToInvite={setUsersToInvite}/>;
};

export default AdminInviteZone;
